import { FormConfigurationProvider, LockIcon, TableIcon } from '@equifinance/shared';
import { ActionButton } from '../../CasesTable/CasesTable';
import { PaddedSection, SectionProps } from '../../Account/components/Section';
import { useCompanyContext } from '../../../contexts/company';

export function BrokerDetailGenericSection(props: SectionProps & { onClickEdit?(e: any): void }) {
  const { sectionLockedStatus, setLockedStatus } = useCompanyContext();
  const { refName, children, onClickEdit } = props;

  const onClickEditButton = (e: any) => {
    e.stopPropagation();
    setLockedStatus(refName!, false);
    onClickEdit?.(e);
  };

  const isLocked = sectionLockedStatus[refName!];
  const EditButton = isLocked ? <ActionButton onClick={onClickEditButton}><TableIcon className="mi-edit" /></ActionButton> : <></>;

  return (
    <PaddedSection
      {...props}
      titleIcon={isLocked ? <LockIcon /> : <></>}
      groupButtons={[EditButton]}
    >
      <FormConfigurationProvider isReadOnlyInput={isLocked}>
        {children}
      </FormConfigurationProvider>
    </PaddedSection>
  );
}
